/**
 * Matches server middleware allow-list (active subscriptions only).
 */
export function isSubscriptionActive(status: string | null | undefined): boolean {
  return status === 'active' || status === 'trialing';
}

/** Paid subscription only — trialing users still need Checkout to convert. */
export function isPaidSubscriptionActive(status: string | null | undefined): boolean {
  return status === 'active';
}

/** Customer Portal: cancel, update card, invoices on an existing paid sub. */
export function canManageBillingInPortal(status: string | null | undefined): boolean {
  return status === 'active';
}

/** Stripe Checkout: trialing early upgrade or resubscribe after lapse. */
export function needsCheckoutToSubscribe(status: string | null | undefined): boolean {
  return !canManageBillingInPortal(status);
}

export function isTrialing(status: string | null | undefined): boolean {
  return status === 'trialing';
}

export function isTrialCancellationScheduled(
  status: string | null | undefined,
  cancelAtPeriodEnd: boolean | null | undefined
): boolean {
  return isTrialing(status) && cancelAtPeriodEnd === true;
}

export function formatSubscriptionStatus(status: string | null | undefined): string {
  if (!status) return 'None';
  const map: Record<string, string> = {
    active: 'Active',
    trialing: 'Trial',
    past_due: 'Past due',
    canceled: 'Canceled',
    unpaid: 'Unpaid',
    incomplete: 'Incomplete',
    incomplete_expired: 'Incomplete (expired)',
    paused: 'Paused',
  };
  return map[status] ?? status;
}
